// extracted by mini-css-extract-plugin
export default {"list":"styles-module__list--Wrafr","link":"styles-module__link--epRE2","linkActive":"styles-module__linkActive--vEbAX","hx":"styles-module__hx--gfC0R"};